import type { FiscalYear } from 'models';

export default function getNearestPastFiscalYear(
  fiscalYearsList: FiscalYear[]
) {
  const now = Date.now();

  let diff = 0;
  let nearestPastFiscalYear: FiscalYear | null = null;

  for (let fiscalYear of fiscalYearsList) {
    const startDate = new Date(fiscalYear.StartDate).getTime();

    if (startDate < now) {
      let currentDiff = now - startDate;

      if ((diff === 0 && !nearestPastFiscalYear) || currentDiff < diff) {
        diff = currentDiff;
        nearestPastFiscalYear = fiscalYear;
      }
    }
  }

  return nearestPastFiscalYear;
}
